import React, { useState, useEffect } from "react";
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import "./featurelist1.css";
import PharmMedicine from "./PharmMedicine";
import PharmMedicineQP from "./PharmMedicinQP";
import ExcelUploader from "./ExcelUploader";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Addmedicine from "./Addmedicine";

function PharmMedHome() {
     const [addRentalShow, setAddRentalShow] = useState(false);
    const [modalShow, setModalShow] = useState(false)
    const [selected,setSelected]=useState("global")
    const [refresh,setRefresh]=useState(false)
    const rentalModalClose = () => {
        setAddRentalShow(false);
         setRefresh(!refresh);
        
      };
      const AddRentalPopUp = (props) => {
        return (
          <Modal
            {...props}
            aria-labelledby="example-custom-modal-styling-title"
            backdrop="static"
            keyboard={false}
            size="lg"
          >
            <Modal.Header style={{ padding: "0px", paddingRight: "2%" }} closeButton>
              <h4 className="title-of-page">Add Medicine</h4>
            </Modal.Header >
            <Modal.Body>
              <Addmedicine
                modalClose={rentalModalClose}
               
              />
            </Modal.Body>
    
          </Modal>
        );
      };
      
return(<div style={{}}>
    <div style={{display:"flex",marginBottom:"3%"}}>
    <button className="clinic_button col-2" style={{backgroundColor:selected==="global"?"#55479F":"white",color:selected==="global"?"white":"#55479F",}} onClick={() => {setSelected("global")}}>Global Medicine List</button>
    <button className="clinic_button col-2" style={{backgroundColor:selected==="local"?"#55479F":"white",color:selected==="local"?"white":"#55479F",}}onClick={() => {setSelected("local")}}>Client Medicine List</button>
     
     <div className="col-4"></div>
     <div className="col-4" style={{ display: 'flex'}}>
                  <button
                    style={{ width: "fit-content", marginLeft: "auto",backgroundColor:"#2b69a3" }}
                    className="add-btn"
                    onClick={() => setModalShow(true)}
                  >
                    Upload Medicine
                  </button>
                  &nbsp;
                  <button
                    style={{ width: "fit-content", marginLeft: "auto" ,backgroundColor:"#2b69a3"}}
                    className="add-btn"
                    onClick={() => setAddRentalShow(true)}
                  >
                    Add Medicine <i class="fas fa-plus"></i>
                  </button>
                </div>
    </div>
    {selected==="global"?<PharmMedicine refresh={refresh}/>:<PharmMedicineQP refresh={refresh}/>}
  
    {modalShow ? (
        <ExcelUploader show={modalShow} onHide={() => setModalShow(false)} />
      ) : null}
      {addRentalShow ? (
            <AddRentalPopUp
              show={addRentalShow}
              onHide={() => setAddRentalShow(false)}
            />
          ) : null}
    </div>
)
}
export default PharmMedHome;
